import { useRef, useState } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
} from '@material-ui/core';
import SelectAutocompleteEnterprise from 'src/pages/enterprises/components/SelectAutocompleteEnterprise';
import { useEnterprise } from 'src/pages/enterprises/hooks/useEnterprise';
import { InfoOutlined } from '@material-ui/icons';
import { useAuth } from '../../hooks/useAuth';
import ThemeSwitch from '../ThemeSwitch/ThemeSwitch';

const AccountPopover: FC = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { user, logout } = useAuth();
  const { selectedEnterprise } = useEnterprise();

  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLogout = async (): Promise<void> => {
    try {
      handleClose();
      await logout();
      navigate('/');
    } catch (err) {
      console.error(err);
      toast.error('Unable to logout.');
    }
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Avatar
          src={selectedEnterprise?.avatar?.url || ''}
          sx={{
            height: 32,
            width: 32,
          }}
        />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography color="textPrimary" variant="subtitle2">
            {user?.name}
          </Typography>
          <Typography color="textSecondary" variant="subtitle2">
            {user?.email}
          </Typography>
          <Box mt={2}>
            <SelectAutocompleteEnterprise />
          </Box>
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          {/* <MenuItem component={RouterLink} to="/perfil">
            <ListItemIcon>
              <User fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  Perfil
                </Typography>
              }
            />
          </MenuItem>
          <Box mt={2}>
            <Divider />
          </Box> */}
          <Box sx={{ mt: 2, ml: 0.75, display: 'flex', alignItems: 'center' }}>
            <ThemeSwitch />
            <Typography color="GrayText" variant="subtitle2">
              Tema
            </Typography>
          </Box>
          <MenuItem>
            <ListItemIcon>
              <InfoOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="GrayText" variant="subtitle2">
                  Versão {process.env.REACT_APP_VERSION}
                </Typography>
              }
            />
          </MenuItem>
          {/* <MenuItem component={RouterLink} to="/perfil">
            <ListItemIcon>
              <CogIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  Configurações
                </Typography>
              }
            />
          </MenuItem> */}
        </Box>
        <Box sx={{ p: 2 }}>
          <Button color="primary" fullWidth onClick={handleLogout} variant="outlined">
            Sair
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default AccountPopover;
